import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TuiLet } from '@taiga-ui/cdk';
import { TuiTextfieldControllerModule, TuiInputModule } from '@taiga-ui/legacy';
import { TuiAccordion, TuiCheckbox, TuiAvatar } from '@taiga-ui/kit';
import { TuiIcon, TuiButton, TuiFallbackSrcPipe, TuiInitialsPipe, TuiAutoColorPipe } from '@taiga-ui/core';
import { SharedModule } from '@src/app/shared';
import { DictionaryItemComponent } from '@src/app/modules/accordion-levels/components/dictionary-item/dictionary-item.component';

import { TestingModule } from '../testing/testing.module';

import { AccordionLevelsComponent } from './accordion-levels.component';
import { CommitteeItemComponent } from './components/committee-item/committee-item.component';

@NgModule({
  declarations: [AccordionLevelsComponent, CommitteeItemComponent, DictionaryItemComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ...TuiAccordion,
    TuiAvatar,
    TuiButton,
    TuiInputModule,
    TuiLet,
    TuiTextfieldControllerModule,
    TuiCheckbox,
    TuiIcon,
    TestingModule,
    TuiFallbackSrcPipe,
    TuiInitialsPipe,
    TuiAutoColorPipe,
  ],
  exports: [AccordionLevelsComponent],
})
export class AccordionLevelsModule {}
